<div class="tw-flex tw-h-full tw-min-h-0 tw-flex-1 tw-flex-col tw-gap-0">
  <div class="tw-flex tw-w-full tw-shrink-0 tw-flex-col tw-border-b tw-border-solid tw-border-gray-200" role="tablist">
    <div class="tw-flex tw-w-full tw-items-center">
      @for (template of templates; track template.id) {
        <button
          type="button"
          role="tab"
          class="tw-flex tw-h-9 tw-flex-1 tw-cursor-pointer tw-items-center tw-justify-center tw-border-0 tw-border-b-2 tw-border-solid tw-bg-transparent tw-px-1 tw-pb-2.5 tw-font-inter tw-text-sm tw-font-medium tw-leading-tight tw-transition-colors focus:tw-outline-none"
          [ngClass]="tabButtonClass(template.id)"
          (click)="onSelectTemplate(template.id)"
        >
          {{ template.label }}
        </button>
      }
    </div>
  </div>

  <div
    class="tw-mt-0 tw-box-border tw-flex tw-min-h-0 tw-flex-1 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-[#c3cee3] tw-bg-[#E9DBD8] tw-px-4 tw-py-8"
  >
    <img
      class="tw-block tw-h-full tw-max-h-full tw-w-auto tw-max-w-full tw-object-contain tw-object-center"
      [src]="activePreviewUrl()"
      [alt]="'WhatsApp template ' + selectedTemplateId() + ' preview'"
    />
  </div>
</div>
